/**
 * Color palette used for the user-selectable primary and secondary theme
 * colors. Each color defines a (background, foreground) pair for both light
 * and dark mode so the text on top of the color always has enough contrast.
 */

export interface ColorShade {
  bg: string
  fg: string
}

export interface ColorOption {
  name: string
  label: string
  light: ColorShade
  dark: ColorShade
}

export const COLOR_OPTIONS: ColorOption[] = [
  {
    name: "indigo",
    label: "Indigo",
    light: { bg: "#4f46e5", fg: "#ffffff" },
    dark: { bg: "#818cf8", fg: "#1e1b4b" },
  },
  {
    name: "blue",
    label: "Blue",
    light: { bg: "#2563eb", fg: "#ffffff" },
    dark: { bg: "#60a5fa", fg: "#172554" },
  },
  {
    name: "violet",
    label: "Violet",
    light: { bg: "#7c3aed", fg: "#ffffff" },
    dark: { bg: "#a78bfa", fg: "#2e1065" },
  },
  {
    name: "purple",
    label: "Purple",
    light: { bg: "#9333ea", fg: "#ffffff" },
    dark: { bg: "#c084fc", fg: "#3b0764" },
  },
  {
    name: "pink",
    label: "Pink",
    light: { bg: "#db2777", fg: "#ffffff" },
    dark: { bg: "#f472b6", fg: "#500724" },
  },
  {
    name: "rose",
    label: "Rose",
    light: { bg: "#e11d48", fg: "#ffffff" },
    dark: { bg: "#fb7185", fg: "#4c0519" },
  },
  {
    name: "red",
    label: "Red",
    light: { bg: "#dc2626", fg: "#ffffff" },
    dark: { bg: "#f87171", fg: "#450a0a" },
  },
  {
    name: "orange",
    label: "Orange",
    light: { bg: "#ea580c", fg: "#ffffff" },
    dark: { bg: "#fb923c", fg: "#431407" },
  },
  {
    name: "amber",
    label: "Amber",
    light: { bg: "#d97706", fg: "#ffffff" },
    dark: { bg: "#fbbf24", fg: "#451a03" },
  },
  {
    name: "emerald",
    label: "Emerald",
    light: { bg: "#059669", fg: "#ffffff" },
    dark: { bg: "#34d399", fg: "#022c22" },
  },
  {
    name: "teal",
    label: "Teal",
    light: { bg: "#0d9488", fg: "#ffffff" },
    dark: { bg: "#2dd4bf", fg: "#042f2e" },
  },
  {
    name: "cyan",
    label: "Cyan",
    light: { bg: "#0891b2", fg: "#ffffff" },
    dark: { bg: "#22d3ee", fg: "#083344" },
  },
  {
    name: "slate",
    label: "Slate",
    light: { bg: "#475569", fg: "#ffffff" },
    dark: { bg: "#94a3b8", fg: "#0f172a" },
  },
]

export const COLOR_OPTIONS_BY_NAME: Record<string, ColorOption> = Object.fromEntries(
  COLOR_OPTIONS.map((c) => [c.name, c]),
)

export function getColorOption(name: string | undefined | null): ColorOption {
  if (name && COLOR_OPTIONS_BY_NAME[name]) {
    return COLOR_OPTIONS_BY_NAME[name]
  }
  return COLOR_OPTIONS_BY_NAME.indigo
}
